import { FC, ReactNode } from "react";

type PageHeroProps = {
  bkg_a: string;
  bkg_b: string;
  sub_head: string;
  main_head: ReactNode;
  description: string;
  children: ReactNode;
}

const PageHero: FC<PageHeroProps> = ({ bkg_a, bkg_b, sub_head, main_head, description, children }) => {
  return (
    <section className="mt-[90px]">
      {/* Fist Column */}
      <div className="w-full h-[40px] bg-primaryDark-400"></div>

      {/* Second Column */}
      <div className="w-full h-auto">
        <img
          src={bkg_a}
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Third Column */}
      <div className="px-[40px] py-[30px]">
        <p className="text-[16px] font-open-sans font-bold text-primaryDark-0 mb-[10px]">
          {sub_head}
        </p>

        {/* Header */}
        <h3 className="text-[36px] font-raleway font-bold text-primaryDark-0 leading-tight mb-[16px]">
          {main_head}
        </h3>

        {/* Description */}
        <p className="text-[16px] font-text-0 font-open-sans mb-[16px] leading-loose">
          {description}
        </p>

        {/* Button */}
        <div>{children}</div>
      </div>

      {/* Fourth Column */}
      <div className="w-full h-auto mb-[4px]">
        <img src={bkg_b} alt="Hero Background" className="w-full h-full object-cover" />
      </div>

      {/* Fifth Column */}
      <div className="w-full h-[40px] bg-primaryDark-400"></div>
    </section>
  );
}

export default PageHero;